import React from "react";
import FadeIn from "./FadeIn";

const PageHero = ({ title, eyebrow, subtitle, light = false }) => (
  <section className={`relative py-16 md:py-20 overflow-hidden ${light ? "bg-ku-gradient" : "bg-ku-purple-deep"}`}>
    <div className="absolute inset-0 bg-noise opacity-20" aria-hidden />
    {/* Decorative blobs */}
    <div className="absolute -top-20 -right-20 w-80 h-80 rounded-full bg-ku-gold/8 blur-3xl pointer-events-none" />
    <div className="absolute -bottom-10 -left-10 w-60 h-60 rounded-full bg-white/5 blur-3xl pointer-events-none" />

    <div className="ku-container relative text-center">
      <FadeIn>
        {eyebrow && (
          <span className="ku-eyebrow text-ku-gold">{eyebrow}</span>
        )}
        <h1 className="font-display text-4xl sm:text-5xl md:text-6xl font-bold text-white mt-3 mb-4 leading-tight">
          {title}
        </h1>
        {subtitle && (
          <p className="font-body text-white/80 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed">
            {subtitle}
          </p>
        )}
      </FadeIn>
    </div>
  </section>
);

export default PageHero;
